import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "AapkaPG";
const SITE_URL = "https://aapkapg.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const SEO = ({
  title,
  description,
  canonicalUrl,
  noIndex = false,
  imageUrl = DEFAULT_IMAGE,
  keywords = [],
  author = SITE_NAME,
  type = "website",
}) => {
  const fullTitle =
    title || "Find Verified PG Accommodation Near You | Zero Brokerage | AapkaPG";

  const fullDescription =
    description ||
    "Search, compare & book verified PGs across India for boys, girls, students and professionals. Zero brokerage, real photos, instant booking on AapkaPG.";

  const fullCanonical = canonicalUrl
    ? canonicalUrl.startsWith("http")
      ? canonicalUrl
      : `${SITE_URL}${canonicalUrl}`
    : SITE_URL;

  return (
    <Helmet prioritizeSeoTags>
      {/* Basic SEO */}
      <title>{fullTitle}</title>

      <meta name="description" content={fullDescription} />
      <meta name="author" content={author} />

      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(", ")} />
      )}

      <meta
        name="robots"
        content={noIndex ? "noindex,nofollow" : "index,follow"}
      />

      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;